import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import PageHeader from "../../components/layout/PageHeader";

export default function OrderConfirmation() {
  const orderId = "SR" + Math.floor(100000 + Math.random() * 900000);
  return (
    <>
      <PageHeader title="Order Confirmed" crumbs={[{ label: "Order Confirmation" }]} />
      <section className="section">
        <div className="container">
          <div className="confirm-box">
            <div className="confirm-icon"><FaCheckCircle /></div>
            <h2 style={{ fontSize: 32 }}>Thank You for Your Order!</h2>
            <p className="sec-text mt-2">
              Your order has been placed successfully. A confirmation email with
              your order details is on its way.
            </p>
            <div className="card" style={{ padding: 24, margin: "28px 0", display: "inline-block" }}>
              <span style={{ color: "var(--gray-light)" }}>Order Number</span>
              <h3 className="text-yellow" style={{ fontSize: 26 }}>{orderId}</h3>
            </div>
            <div className="flex gap-2 wrap" style={{ justifyContent: "center" }}>
              <Link to="/shop-grid" className="btn btn-primary">Continue Shopping</Link>
              <Link to="/" className="btn btn-outline">Back to Home</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
